import React, { useCallback, useEffect, useState, useRef } from 'react';
import { FlatSprout } from '../components/FlatSprout';
import { FlatForest } from '../components/FlatForest';
import { RomaMapWithTrees } from '../components/RomaMapWithTrees';
import { ArrowRight } from 'lucide-react';
interface Props {
  onContinue: () => void;
}
export function OnboardingSprout({
  onContinue
}: Props) {
  const [slide, setSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [mounted, setMounted] = useState(false);
  const [slideAnimReady, setSlideAnimReady] = useState(false);
  const totalSlides = 5;
  const videoRef = useCallback((node: HTMLVideoElement | null) => {
    if (node) {
      node.play().catch(() => {});
    }
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => {
      setMounted(true);
      setSlideAnimReady(true);
    }, 50);
    return () => clearTimeout(timer);
  }, []);
  const next = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setSlideAnimReady(false);
    setTimeout(() => {
      if (slide < totalSlides - 1) {
        setSlide(slide + 1);
      } else {
        onContinue();
      }
      setTimeout(() => {
        setIsTransitioning(false);
        setTimeout(() => setSlideAnimReady(true), 100);
      }, 80);
    }, 380);
  };
  return <div className="flex flex-col h-full w-full bg-[#0D0D0D] px-6 pt-6 pb-6 relative overflow-hidden" data-id="element-407">
      {/* Background video — only on slide 0 */}
      {slide === 0 && <>
          <video ref={videoRef} autoPlay loop muted playsInline preload="auto"
      // @ts-ignore — webkit-playsinline for older iOS
      webkit-playsinline="" className="absolute inset-0 w-full h-full object-cover z-0" style={{
        opacity: slideAnimReady ? 0.35 : 0,
        transition: 'opacity 900ms cubic-bezier(0.4, 0, 0.2, 1)'
      }} src="https://video.wixstatic.com/video/dc6efb_f97d8ca171e342a39937f8fa5adb1258/720p/mp4/file.mp4" data-id="element-408" />
          {/* Dark gradient overlay */}
          <div className="absolute inset-0 z-0 bg-gradient-to-b from-[#0D0D0D]/60 via-transparent to-[#0D0D0D]" data-id="element-409" />
        </>}
      {/* Dot Indicators */}
      <div className="flex justify-center gap-2 mb-8 relative z-10" style={{
      opacity: mounted ? 1 : 0,
      transform: mounted ? 'translateY(0)' : 'translateY(16px)',
      transition: 'opacity 800ms cubic-bezier(0.4, 0, 0.2, 1), transform 800ms cubic-bezier(0.4, 0, 0.2, 1)'
    }} data-id="element-410">
        {Array.from({
        length: totalSlides
      }).map((_, i) => <div key={i} className={`h-1.5 rounded-full transition-all duration-500 ease-out ${i === slide ? 'w-6 bg-[#C5D82D]' : 'w-1.5 bg-[#2A2A2A]'}`} data-id="element-411" />)}
      </div>

      {/* Slide Content */}
      <div className="flex-1 flex flex-col items-center justify-center relative z-10" data-id="element-412">
        <div className="w-full flex flex-col items-center" style={{
        opacity: isTransitioning ? 0 : 1,
        transform: isTransitioning ? 'translateY(-10px) scale(0.98)' : 'translateY(0) scale(1)',
        transition: isTransitioning ? 'opacity 350ms cubic-bezier(0.4, 0, 0.6, 1), transform 350ms cubic-bezier(0.4, 0, 0.6, 1)' : 'opacity 500ms cubic-bezier(0.4, 0, 0.2, 1), transform 500ms cubic-bezier(0.4, 0, 0.2, 1)'
      }} data-id="element-413">
          {/* Slide 0 — Benvenuto */}
          {slide === 0 && <div className="flex flex-col items-center text-center" data-id="element-414">
              {/* Visual area */}
              <div className="flex flex-col items-center justify-center" style={{
            opacity: slideAnimReady ? 1 : 0,
            transform: slideAnimReady ? 'translateY(0)' : 'translateY(14px)',
            transition: 'opacity 800ms cubic-bezier(0.4, 0, 0.2, 1), transform 800ms cubic-bezier(0.4, 0, 0.2, 1)',
            transitionDelay: '0ms'
          }} data-id="element-415">
                <img src="https://static.wixstatic.com/media/6e7739_2497b1d974164d3ebd4c4ad72f6d0b73~mv2.png/v1/crop/x_0,y_21,w_4505,h_1713/fill/w_266,h_100,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Logo%20EIIS_bianco.png" alt="EIIS" className="h-12 object-contain" data-id="element-416" />
                <h1 className="font-medium text-white tracking-tight mt-4 text-[21px]" data-id="element-417">
                  Benvenuto al Summit 2026
                </h1>
              </div>
              {/* Text area */}
              <div className="flex flex-col items-center gap-3 mt-4" style={{
            opacity: slideAnimReady ? 1 : 0,
            transform: slideAnimReady ? 'translateY(0)' : 'translateY(14px)',
            transition: 'opacity 800ms cubic-bezier(0.4, 0, 0.2, 1), transform 800ms cubic-bezier(0.4, 0, 0.2, 1)',
            transitionDelay: '120ms'
          }} data-id="element-418">
                <p className="max-w-[280px] text-center text-[16px] text-[#FFFFFF]" data-id="element-419">
                  Questa è l'app ufficiale dell'EIIS Summit. Il tuo compagno per
                  vivere l'evento, creare connessioni e lasciare un segno
                  concreto.
                </p>
              </div>
            </div>}

          {/* Slide 1 — EIIS × Roma Capitale */}
          {slide === 1 && <div className="flex flex-col items-center text-center" data-id="element-420">
              {/* Logos area */}
              <div className="flex flex-col items-center justify-center" style={{
            opacity: slideAnimReady ? 1 : 0,
            transform: slideAnimReady ? 'translateY(0)' : 'translateY(14px)',
            transition: 'opacity 800ms cubic-bezier(0.4, 0, 0.2, 1), transform 800ms cubic-bezier(0.4, 0, 0.2, 1)',
            transitionDelay: '0ms'
          }} data-id="element-421">
                <div className="flex items-center gap-5" data-id="element-422">
                  <img src="https://static.wixstatic.com/media/6e7739_2497b1d974164d3ebd4c4ad72f6d0b73~mv2.png/v1/crop/x_0,y_21,w_4505,h_1713/fill/w_266,h_100,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Logo%20EIIS_bianco.png" alt="EIIS" className="h-10 object-contain" data-id="element-423" />

                  <img src="https://cdn.magicpatterns.com/uploads/6pmTDzdtAwSUygH2K5ESYb/logo_roma_footer.png" alt="Roma Capitale" className="h-10 object-contain" data-id="element-424" />
                </div>
                <h1 className="font-medium text-white tracking-tight mt-6 text-[21px] max-w-[300px]" data-id="element-425">
                  Quest'anno le connessioni diventano alberi
                </h1>
              </div>
              {/* Text area */}
              <div className="flex flex-col items-center gap-3 mt-5" style={{
            opacity: slideAnimReady ? 1 : 0,
            transform: slideAnimReady ? 'translateY(0)' : 'translateY(14px)',
            transition: 'opacity 800ms cubic-bezier(0.4, 0, 0.2, 1), transform 800ms cubic-bezier(0.4, 0, 0.2, 1)',
            transitionDelay: '120ms'
          }} data-id="element-426">
                <p className="max-w-[290px] text-center text-[15px] text-[#BBBBBB] leading-relaxed" data-id="element-427">
                  EIIS e Roma Capitale collaborano per piantare una foresta
                  nella città. La novità di quest'anno: ogni connessione che
                  farai al Summit contribuirà a far crescere un albero vero.
                </p>
              </div>
            </div>}

          {/* Slide 2 — Il tuo seme */}
          {slide === 2 && <div className="flex flex-col items-center text-center" data-id="element-428">
              <div className="h-[180px] flex items-center justify-center" style={{
            opacity: slideAnimReady ? 1 : 0,
            transform: slideAnimReady ? 'translateY(0)' : 'translateY(14px)',
            transition: 'opacity 800ms cubic-bezier(0.4, 0, 0.2, 1), transform 800ms cubic-bezier(0.4, 0, 0.2, 1)',
            transitionDelay: '0ms'
          }} data-id="element-429">
                <FlatSprout data-id="element-430" />
              </div>
              <div className="flex flex-col items-center gap-3 mt-8" style={{
            opacity: slideAnimReady ? 1 : 0,
            transform: slideAnimReady ? 'translateY(0)' : 'translateY(14px)',
            transition: 'opacity 800ms cubic-bezier(0.4, 0, 0.2, 1), transform 800ms cubic-bezier(0.4, 0, 0.2, 1)',
            transitionDelay: '120ms'
          }} data-id="element-431">
                <h1 className="text-[21px] font-medium text-white tracking-tight" data-id="element-432">
                  Questo è il tuo seme
                </h1>
                <p className="text-[14px] text-[#888888] max-w-[280px] leading-relaxed" data-id="element-433">
                  Ogni partecipante al Summit riceve un seme digitale. Il tuo
                  obiettivo? Farlo crescere fino a diventare un albero vero.
                </p>
              </div>
            </div>}

          {/* Slide 3 — Le connessioni */}
          {slide === 3 && <div className="flex flex-col items-center text-center" data-id="element-434">
              <div className="h-[140px] flex items-center justify-center" style={{
            opacity: slideAnimReady ? 1 : 0,
            transform: slideAnimReady ? 'translateY(0)' : 'translateY(14px)',
            transition: 'opacity 800ms cubic-bezier(0.4, 0, 0.2, 1), transform 800ms cubic-bezier(0.4, 0, 0.2, 1)',
            transitionDelay: '0ms'
          }} data-id="element-435">
                <div className="relative" data-id="element-436">
                  <div className="relative flex items-center justify-center" data-id="element-437">
                    <div className="absolute left-0 top-0 bottom-0 w-10 z-10 bg-gradient-to-r from-[#0D0D0D] to-transparent pointer-events-none" data-id="element-438" />
                    <div className="absolute right-0 top-0 bottom-0 w-10 z-10 bg-gradient-to-l from-[#0D0D0D] to-transparent pointer-events-none" data-id="element-439" />
                    <div className="flex items-center -space-x-5" data-id="element-440">
                      {/* Left avatar — blurred identity */}
                      <div className="w-24 h-24 rounded-full border-2 border-[#0D0D0D] opacity-60 bg-[#1A1A1A] flex items-center justify-center" data-id="element-441">
                        <span className="text-[28px] text-[#555555]" data-id="element-442">?</span>
                      </div>
                      {/* Center avatar — you */}
                      <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=160&h=160&fit=crop&crop=face" alt="" className="w-28 h-28 rounded-full object-cover border-2 border-[#0D0D0D] relative z-[5]" data-id="element-443" />
                      {/* Right avatar — blurred identity */}
                      <div className="w-24 h-24 rounded-full border-2 border-[#0D0D0D] opacity-60 bg-[#1A1A1A] flex items-center justify-center" data-id="element-444">
                        <span className="text-[28px] text-[#555555]" data-id="element-445">?</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-col items-center gap-3 mt-3" style={{
            opacity: slideAnimReady ? 1 : 0,
            transform: slideAnimReady ? 'translateY(0)' : 'translateY(14px)',
            transition: 'opacity 800ms cubic-bezier(0.4, 0, 0.2, 1), transform 800ms cubic-bezier(0.4, 0, 0.2, 1)',
            transitionDelay: '120ms'
          }} data-id="element-446">
                <h1 className="text-[21px] font-medium text-white tracking-tight" data-id="element-447">
                  Come farlo crescere? Con le connessioni.
                </h1>
                <p className="text-[14px] text-[#888888] max-w-[280px] leading-relaxed" data-id="element-448">
                  Ti proporremo di parlare di un tema con un altro partecipante.
                  Saprai i suoi interessi e progetti, ma non la sua identità —
                  la scoprirai solo incontrandovi.
                </p>
              </div>
            </div>}

          {/* Slide 4 — Il traguardo */}
          {slide === 4 && <div className="flex flex-col items-center text-center" data-id="element-449">
              <div className="h-[180px] flex items-center justify-center w-full" style={{
            opacity: slideAnimReady ? 1 : 0,
            transform: slideAnimReady ? 'translateY(0)' : 'translateY(14px)',
            transition: 'opacity 800ms cubic-bezier(0.4, 0, 0.2, 1), transform 800ms cubic-bezier(0.4, 0, 0.2, 1)',
            transitionDelay: '0ms'
          }} data-id="element-450">
                <FlatForest data-id="element-451" />
              </div>
              <div className="flex flex-col items-center gap-3 mt-8" style={{
            opacity: slideAnimReady ? 1 : 0,
            transform: slideAnimReady ? 'translateY(0)' : 'translateY(14px)',
            transition: 'opacity 800ms cubic-bezier(0.4, 0, 0.2, 1), transform 800ms cubic-bezier(0.4, 0, 0.2, 1)',
            transitionDelay: '120ms'
          }} data-id="element-452">
                <h1 className="text-[21px] font-medium text-white tracking-tight" data-id="element-453">
                  5 connessioni, 1 albero vero
                </h1>
                <p className="text-[14px] text-[#888888] max-w-[280px] leading-relaxed" data-id="element-454">
                  Dopo 5 connessioni il tuo albero sarà completo e entrerà nella
                  foresta della community. A fine Summit, ogni albero diventerà
                  reale e verrà piantato a Roma.
                </p>
              </div>
            </div>}
        </div>
      </div>

      {/* Bottom Button */}
      <div className="mt-auto pt-8 pb-4 relative z-10" style={{
      opacity: mounted ? 1 : 0,
      transform: mounted ? 'translateY(0)' : 'translateY(16px)',
      transition: 'opacity 800ms cubic-bezier(0.4, 0, 0.2, 1), transform 800ms cubic-bezier(0.4, 0, 0.2, 1)',
      transitionDelay: '200ms'
    }} data-id="element-455">
        <button onClick={next} className="w-full bg-transparent border border-[#C5D82D] text-white rounded-full py-3.5 font-medium text-base transition-all duration-200 active:scale-[0.98] flex items-center justify-center gap-2" data-id="element-456">
          {slide === totalSlides - 1 ? 'Iniziamo' : 'Avanti'}
          <ArrowRight className="w-4 h-4" data-id="element-457" />
        </button>
      </div>
    </div>;
}